/* Absolute, shared campaign clock; scoped to the opted-in USA T5 presale surfaces. */
if (!customElements.get('ys-t5-final-call')) {
  customElements.define('ys-t5-final-call', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.initializing) return;
      this.initializing = true;
      queueMicrotask(() => {
        this.initializing = false;
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.end = Date.parse(this.dataset.deadline);
        this.owner = this.closest('[data-t5-final-offer]');
        this.units = Object.fromEntries([...this.querySelectorAll('[data-tfc-unit]')].map(el => [el.dataset.tfcUnit, el]));
        this.phase = this.querySelector('[data-tfc-phase]');
        this.update = () => {
          const valid = Number.isFinite(this.end);
          const remaining = valid ? Math.max(0, Math.ceil((this.end - Date.now()) / 1000)) : 0;
          // Fail closed for invalid dates; never show an invented countdown.
          const ended = !valid || Date.now() >= this.end;
          this.dataset.state = ended ? 'ended' : 'active';
          if (this.owner) this.owner.dataset.t5OfferEnded = String(ended);
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
          for (const [key, value] of Object.entries(values)) {
            const text = String(value).padStart(2, '0');
            if (this.units[key] && this.units[key].textContent !== text) this.units[key].textContent = text;
          }
          if (this.phase) {
            this.phase.dataset.label ||= this.phase.textContent;
            this.phase.textContent = (!ended && remaining <= 86400 ? 'Final hours · ' : '') + this.phase.dataset.label;
          }
          if (ended) this.stop();
        };
        this.resume = () => {
          this.stop();
          this.update();
          if (!document.hidden && Number.isFinite(this.end) && this.end > Date.now()) this.timer = setInterval(this.update, 1000);
        };
        document.addEventListener('visibilitychange', this.resume, { signal: this.controller.signal });
        window.addEventListener('pageshow', this.resume, { signal: this.controller.signal });
        this.resume();
      });
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
  });
}

// Product allocation retains the existing interpolation. It is not a live order feed.
if (!customElements.get('ys-t5-product-presale')) {
  customElements.define('ys-t5-product-presale', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.initializing) return;
      this.initializing = true;
      queueMicrotask(() => {
        this.initializing = false;
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const anchor = Number(this.dataset.anchor), end = Date.parse(this.dataset.endTime);
        const initial = Number(this.dataset.initial) || 0, target = Number(this.dataset.endTarget);
        const total = Number(this.dataset.total) || 1, word = this.dataset.counterWord || '';
        const bar = this.querySelector('[role=progressbar]'), fill = this.querySelector('[data-progress-fill]');
        const value = this.querySelector('[data-progress-value]');
        this.render = () => {
          const now = Date.now();
          const fraction = end > anchor && anchor > 0 ? Math.min(1, Math.max(0, (now - anchor) / (end - anchor))) : 0;
          const count = Math.max(0, Math.min(total, Math.floor(initial + (target - initial) * fraction)));
          if (fill) fill.style.width = (count / total * 100).toFixed(3) + '%';
          if (value) value.textContent = count + '/' + total + (word ? ' ' + word : '');
          if (bar) bar.setAttribute('aria-valuenow', String(count));
          if (now >= end) this.stop();
        };
        const toggle = this.querySelector('.ysl-t5-presale__learn-toggle'), panel = this.querySelector('.ysl-t5-presale__details');
        if (toggle && panel) {
          toggle.hidden = false;
          panel.hidden = true;
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded)); panel.hidden = expanded;
          }, { signal: this.controller.signal });
        }
        this.resume = () => {
          this.stop(); this.render();
          if (!document.hidden && end > Date.now()) this.timer = setInterval(this.render, 15000);
        };
        document.addEventListener('visibilitychange', this.resume, { signal: this.controller.signal });
        this.resume();
      });
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
  });
}
